// extracted by mini-css-extract-plugin
export default {"wrapper":"wv0oG5wI","icon":"Vo9PQx7R","name":"pWXf5umh","warning":"CR6VJy5N","modal":"rnxElCn9","extraInfo":"INjBCqPp"};